import { Skeleton } from '@reveni-io/reveni-ui'

import { skeletonRows } from './constants'
import * as Styles from './styles'

const GroupsWithAccessSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="text" width={140} height={16} />
    <Styles.Grid>
      {skeletonRows.map(row => (
        <Skeleton key={row} variant="rounded" height={24} />
      ))}
    </Styles.Grid>
  </Styles.Container>
)

export default GroupsWithAccessSkeleton
